/** Unescape API newlines and trim agreement body text before markdown/HTML render. */
export const normalizeAgreementContent = (raw: string): string => {
  if (!raw) return "";

  let content = raw.trim();

  if (content.includes("\\n")) {
    content = content
      .replace(/\\n/g, "\n")
      .replace(/\\r/g, "\r")
      .replace(/\\t/g, "\t");
  }

  return content;
};

export const containsHtmlMarkup = (content: string): boolean => {
  return /<[a-z][^>]*>/i.test(content);
};

export const shouldShowAgreementTitle = (
  title: string,
  content: string,
): boolean => {
  const normalizedTitle = title.trim().toLowerCase();
  if (!normalizedTitle) return false;

  const normalizedContent = normalizeAgreementContent(content).toLowerCase();

  if (normalizedContent.startsWith(normalizedTitle)) return false;

  const markdownHeading = normalizedTitle.replace(/^\d+\.\s*/, "");
  if (
    normalizedContent.includes(`# ${normalizedTitle}`) ||
    normalizedContent.includes(`## ${normalizedTitle}`) ||
    normalizedContent.includes(`### ${normalizedTitle}`) ||
    normalizedContent.includes(markdownHeading)
  ) {
    return false;
  }

  return true;
};

/** True when the user typed in capitals (e.g. Caps Lock). Does not auto-convert input. */
export const isCapitalSignatureName = (value: string): boolean => {
  const trimmed = value.trim();
  if (!trimmed) return false;
  if (/[a-z]/.test(trimmed)) return false;
  return /[A-Z]/.test(trimmed);
};
